import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const SUB_FACTORS = [
  'AGF',
  'AMC',
  'Arbitrage',
  'Asset Swap',
  'Backwardation',
  'Benchmark',
  'Bond Carry',
  'Bond Curve',
  'Bond Value',
  'Bond Volatility',
  'Carry',
  'Commodity Carry',
  'Commodity Congestion',
  'Commodity Curve',
  'Commodity Momentum',
  'Commodity Value',
  'Commodity Volatility',
  'Congestion',
  'Credit Carry',
  'Credit Volatility',
  'Cross Asset Momentum',
  'Curve',
  'DGF',
  'Dispersion',
  'Dividend',
  'Equities Carry',
  'Equities Congestion',
  'Equities Liquidity',
  'Equities Momentum',
  'Equities Multi Factor',
  'Equities Size',
  'Equities Value',
  'Equities Volatility',
  'Equity',
  'Equity Carry',
  'Equity Low Beta',
  'Equity Momentum',
  'Equity Multi-style',
  'Equity Quality',
  'Equity Size',
  'Equity Value',
  'Equity Volatility',
  'European Equity Vol Arb',
  'FX Carry',
  'FX Congestion',
  'FX Momentum',
  'FX Multi Factor',
  'FX Value',
  'Gold',
  'Hedging',
  'Intraday',
  'Intraday Momentum',
  'Long',
  'Mean Reversion',
  'Mean-Reversion',
  'Multi-Factor',
  'Property',
  'Rates Carry',
  'Rates Curve',
  'Rates Momentum',
  'Rates Multi -strat',
  'Rates Value',
  'Rates Volatility',
  'Relative',
  'SPTR Index',
  'Seasonality',
  'Short',
  'Skew',
  'Term',
  'Time Series',
  'Trend',
  'US Equity Vol Arb',
  'USD',
  'Volatility',
  'X Asset Momentum',
  'X Asset Volatility',
  'X-Sectional',
] as const

export type SubFactor = (typeof SUB_FACTORS)[number]

export const SUB_FACTOR_OPTIONS = sortAlphabeticallyByKey(
  SUB_FACTORS.map((a) => ({ label: a, value: a })),
  'label',
)
